import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

export interface NavDesktopMenuLinkConfig {
  routerLink: string;
  label: string;
  exact?: boolean;
}

@Component({
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  selector: 'lib-nav-desktop-menu-link',
  template: `
    <a
      [routerLink]="config().routerLink"
      routerLinkActive="text-orange-400"
      [routerLinkActiveOptions]="{ exact: config().exact || false }"
      class="text-gray-300 hover:text-white px-3 py-2 text-sm font-medium transition-colors duration-200 border-b-2 border-transparent"
    >
      {{ config().label }}
    </a>
  `,
})
export class NavDesktopMenuLinkComponent {
  config = input.required<NavDesktopMenuLinkConfig>();
}
